import React from "react"
import "./style.scss"
import Carousel from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Link } from "gatsby"

const ArticleItem = ({ topic, content, className, status, path }) => {
  return (
    <Link to={path} style={{ textDecoration: "none" }}>
      <div className={`article_item ${className ? className : ""}`}>
        <div className="status" style={{ background: status }}></div>
        <h3 className="topic">{topic} </h3>
        <p className="content">
          {content ? content.substring(0, 95) + "..." : ""}{" "}
        </p>
      </div>
    </Link>
  )
}
const NextArrow = props => {
  const { className, onClick } = props
  return <div className={`${className} next`} onClick={onClick} />
}

const PrevArrow = props => {
  const { className, onClick } = props
  return <div className={`${className} prev`} onClick={onClick} />
}
const Relatedarticles = ({ posts, title, path }) => {
  let pageLocation = path
  const sectionData = {
    title,
    articles: [
      {
        topic: "Query about the topic?",
        class: "current",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "read",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "unread",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "read",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "unread",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "read",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "read",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "unread",
        content:
          "Small description about the article, Small description about the article",
      },
      {
        topic: "Query about the topic?",
        class: "unread",
        content:
          "Small description about the article, Small description about the article",
      },
    ],
  }
  const settings = {
    slidesToShow: 3,
    speed: 500,
    infinite: false,
    slidesToScroll: 3,
    rows: 2,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  }
  return (
    <div className="related_articles_section">
      <h1 className="title">{sectionData.title}</h1>
      <div className="articles">
        <Carousel {...settings}>
          {posts &&
            posts.map(({ node }, index) => {
              const { id, frontmatter } = node
              const { title, description, path } = frontmatter
              if (index === 0) {
                return (
                  <ArticleItem
                    key={id}
                    className={
                      pageLocation === path
                        ? "current"
                        : frontmatter.class
                        ? frontmatter.class
                        : "current"
                    }
                    topic={title}
                    content={description}
                    path={path}
                  />
                )
              }
              return (
                <ArticleItem
                  key={id}
                  className={
                    pageLocation === path
                      ? "current"
                      : frontmatter.class
                      ? frontmatter.class
                      : "unread"
                  }
                  topic={title}
                  content={description}
                  path={path}
                />
              )
            })}
        </Carousel>
      </div>
    </div>
  )
}

export default Relatedarticles
